module.exports = __webpack_public_path__ + "img/quanquan.d0a9e062.png";